import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { graphql, Link } from 'gatsby'
import Layout from '../layouts'
import Content, { HTMLContent } from '../components/Content'

const IOSWrap = styled.div`
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
`

export const AboutPageTemplate = ({ content, contentComponent }) => {
  const PageContent = contentComponent || Content

  return (
    <section className='section'>
      <div className='columns' style={{ marginTop: '2rem' }}>
        <div className='column is-12'>
          <IOSWrap>
            <PageContent className='content' content={content} />
          </IOSWrap>
          <div className='container' style={{ marginTop: '2rem' }}>
            <div className='columns'>
              <div className='column has-text-centered'>
                <Link className='button is-outlined is-primary' to='/'>zurück
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>

    </section>
  )
}

AboutPageTemplate.propTypes = {
  content: PropTypes.string,
  contentComponent: PropTypes.func
}

const AboutPage = ({ data }) => {
  const { markdownRemark: post, footerData, navbarData, bannerData } = data

  return (
    <Layout navbarData={navbarData} footerData={footerData} bannerData={bannerData}>
      <AboutPageTemplate
        contentComponent={HTMLContent}
        content={post.html}
      />
    </Layout>
  )
}

AboutPage.propTypes = {
  data: PropTypes.object.isRequired
}

export default AboutPage

export const aboutPageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
    }
    ...LayoutFragment
  }
`
